import { Component, Input } from '@angular/core';
import { SlipcaseNewsItem } from 'src/app/models/slipcase-news-item';

@Component({
    selector: 'app-slipcase-feed-item',
    templateUrl: './slipcase-card.component.html',
    styleUrls: ['./slipcase-card.component.css'],
    standalone: false
})
export class SlipcaseCardComponent {

  @Input() newsItem: SlipcaseNewsItem;

  constructor ( ) { }

}
